<template>
  <div id="business">
    <div class="business-info">
      <h5>Colores</h5>
      <div class="colores">
        <div v-for="(color, index) in colores" :key="index" class="chip" :style="{ 'background-color': '#' + color }"></div>
      </div>
    </div>
    <div class="business-info">
      <h5>Tallas</h5>
      <p class="ml-2">{{ tallas }}</p>
    </div>
    <div class="business-info">
      <h5>Precios</h5>
      <p class="ml-2">{{ medianaBaja }} - {{ medianaAlta }} </p>
    </div>
    <!-- <div class="business-info">
      <h5>Tacón</h5>
      <p class="ml-2">3.5cm - 5cm</p>
    </div> -->
    <div class="business-info">
      <h5>Última compra</h5>
      <p class="ml-2">{{ fechaUltimaVisita }}<br>{{ precioUltimaVisita }}</p>
    </div>
  </div>
</template>
<script>
import EventBus from '@/plugins/EventBus'
import { Util } from '@/api/Util'
const util = new Util()

export default {
  name: 'clienteBI',
  data() {
    return {
      precioUltimaVisita: '',
      fechaUltimaVisita: '',
      tallas: '',
      colores: '',
      medianaBaja: '',
      medianaAlta: '' 
    }
  },
  mounted () {
    EventBus.$on('clienteBiUpdate', (payload) => {
      this.precioUltimaVisita = util.formatMoney(payload.ultima.precio)
      if (payload.ultima.fecha !== undefined) {
        this.fechaUltimaVisita = new Date(payload.ultima.fecha.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })
      }
      this.tallas = payload.tallas
      this.colores = payload.colores
      this.medianaBaja = util.formatMoney(payload.medianas[0])
      this.medianaAlta = util.formatMoney(payload.medianas[1])
    })
  },
  methods: {

  },
}
</script>